import { render, staticRenderFns } from "./devBY.vue?vue&type=template&id=79e7450b&scoped=true&"
import script from "./devBY.vue?vue&type=script&lang=js&"
export * from "./devBY.vue?vue&type=script&lang=js&"
import style0 from "./devBY.vue?vue&type=style&index=0&id=79e7450b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e7450b",
  null
  
)

export default component.exports